module.exports = __webpack_public_path__ + "static/media/check-mark.33206f04.svg";